import React from "react";
import "./footer.css";

// icons
import { AiFillInstagram, AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";

const Footer = () => {
    return (
        <footer className="app__footer">
            <div className="app__footer-container">
                <div className="app__footer-contact">
                    <div className="app__footer-contact_header">
                        <h3> Get In touch </h3>
                        <h2> Let's Create <span> Something <br /> Amazing </span> Together </h2>

                        <div className="app__footer-btn">
                            <a href="mailto:emanuelanyigor@gmail.com">
                                <span> Get in touch </span>
                            </a>
                        </div>
                    </div>

                    <div className="app__footer-row d-flex flex-item-center">
                        <div className="app__footer-col">
                            <ul className="app__footer-socials d-flex gap-2">
                                <li className="app__footer-social d-flex">
                                    <a className="d-flex flex-item-center" href="/" target="_blank" rel="noreferrer">
                                        <AiFillGithub />
                                    </a>
                                </li>
                                <li className="app__footer-social d-flex">
                                    <a className="d-flex flex-item-center" href="/" target="_blank" rel="noreferrer">
                                        <BsTwitter />
                                    </a>
                                </li>
                                <li className="app__footer-social d-flex">
                                    <a className="d-flex flex-item-center" href="/" target="_blank" rel="noreferrer">
                                        <AiFillLinkedin />
                                    </a>
                                </li>
                                <li className="app__footer-social d-flex">
                                    <a className="d-flex flex-item-center" href="/" target="_blank" rel="noreferrer">
                                        <AiFillInstagram />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;